// extracted by mini-css-extract-plugin
export default {"slide":"Slideshow_slide__UZJc-","slidesContainer":"Slideshow_slidesContainer__v4lVt"};